package co.laiautomation

import com.laiautomation.kdxp.appmodel.KdxpTargetPlatform

internal actual val currentWebTarget: KdxpTargetPlatform = KdxpTargetPlatform.WEB_JS
